import { getLoggedRole } from 'data-layer-cr/dist/authentication';
import { DisplayItem } from 'design-system';

export const INITIAL_HEIGHT = 42;
export const LINES_HEIGHT = 24;
export const MAX_CHAR_PER_LINE = 32;

const getElementComplement = (element: string): string =>
  element === 'Licencias' ? 'Todas las licencias' : 'Todos los subagentes';

export const getRenderValue = (
  itemList: string[],
  optionListLength = -1,
  element = 'Licencias',
): string => {
  if (itemList.length === 0) {
    return element;
  }
  if (optionListLength === itemList.length) {
    return `${getElementComplement(element)} (+${itemList.length})`;
  }
  if (itemList.length > 1) {
    return `${itemList[0]} (+${itemList.length - 1})`;
  }
  return itemList[0];
};

export const getQueryString = (selected: string[]): string => {
  if (selected.length === 0) {
    return 'default';
  }
  return selected.join(',');
};

export const isCheckAll = (value: string): boolean => value === 'TODAS';

export const filteredOptionList = (
  optionList: DisplayItem[],
  search: string,
): DisplayItem[] => {
  const checkAllButton = { Value: 'TODAS', Text: 'TODAS' };
  const loggedUserRole = getLoggedRole();
  const searchTerm = new RegExp(search, 'i');
  if (search !== '') {
    return optionList.filter((item) => (item.Text as string).match(searchTerm));
  }

  // To avoid query string characters overload, we dont show all button to ASE
  if (loggedUserRole === 'ASE') {
    return optionList;
  }

  return [checkAllButton, ...optionList];
};

export const getItemSize = (text: string): number => {
  const lines = Math.floor(text.length / MAX_CHAR_PER_LINE);
  return INITIAL_HEIGHT + lines * LINES_HEIGHT;
};

export const getListHeight = (list: DisplayItem[]): number => {
  if (list.length < 8) {
    return list.reduce(
      (prev, curr) => getItemSize(curr.Text as string) + prev,
      0,
    );
  }
  return 340;
};
